import api from '@/services/Api';

export default {
    // "aktualnosci"
    getNews(){
        return api.get('/api/v1/news')
    },
    getSingleNews(slug){
        return api.get('/api/v1/news/' + slug)
    },
    // "strefa wiedzy"
    getKnowledgeZone(id){
        let url = '/api/v1/knowledge-zone'
        if(id) url = '/api/v1/knowledge-zone?category='+ id
        return api.get(url)
    },
    getKnowledgeZoneCategories(){
        return api.get('/api/v1/knowledge-zone-categories')
    },
    getSingleKnowledgeZone(slug){
        return api.get('/api/v1/knowledge-zone/' + slug)
    },
}